import { render, staticRenderFns } from "./iconTemporal.vue?vue&type=template&id=1c6ce674"
import script from "./iconTemporal.vue?vue&type=script&lang=js"
export * from "./iconTemporal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports